import React from 'react';
import ReactDOM from 'react-dom/client';
// Token values first: tailwind's config and every stylesheet below resolve
// var(--token) against this :root block.
import './styles/tokens.css';
import './index.css';
// Component styles loaded AFTER tailwind so their base rules win.
import './styles/dashboard.css';
import App from './App';

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
